import { createTheme } from '@mui/material'

const darkBorderColor = 'var(--border-dark-color) !important'

export const primaryCheckboxSx = {
  '&, &.Mui-checked, &.Mui-indeterminate, &.Mui-disabled': { color: 'var(--primary-bg)' }
}
export const lightTheme = createTheme({
  palette: {
    mode: 'light'
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 0
        },
        list: {
          '& li': {
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          },
          '& li.hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          }
        }
      }
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--white)'
        }
      }
    }
  }
})

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    text: {
      primary: '#fff'
    }
  },
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          borderColor: darkBorderColor
        }
      }
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--dark-gray-background)',
          borderColor: darkBorderColor
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: darkBorderColor
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          borderColor: darkBorderColor
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderColor: darkBorderColor
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 0
        },
        list: {
          background: 'var(--dark-chart-bg)',
          color: 'white',
          '& li': {
            '&:hover': {
              backgroundColor: 'rgb(2 2 2 / 45%)'
            }
          },
          '& li.hover': {
            backgroundColor: 'rgb(2 2 2 / 45%)'
          }
        }
      }
    }
  }
})
